<div
    *ngIf="distribution"
    class="agpr-distributionHeader agpr-contextMenu-parent"
    [ngClass]="{'agpr-distributionHeader-editable' : editable}"
    [attr.aria-label]="'Discover.targeting.distribution.header.tooltip' | localize"
    (agprClickUnless)="emitClick()"
>
    <ul class="agpr-contextMenu top right" role="menu" [attr.aria-describedby]="ariaDescribedBy">
        <li role="menuitem">
            <agpr-button
                [id]="'header'"
                *ngIf="editable"
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-duotone fa-pen"
                (click)="emitClick()"
                tooltip="Discover.targeting.distribution.header.editHeader"
                ariaLabel="Discover.targeting.distribution.header.editDistributionHeader"
            ></agpr-button>
        </li>
    </ul>

    <div class="agpr-distributionHeader-subject">
        <label *ngIf="distribution.subjectLine">
            {{distribution.status !== distributionStatus.draft
                ? subjectLine
                : distribution.subjectLine}}
        </label>
        <label
            *ngIf="!distribution.subjectLine"
            class="agpr-distributionHeader-placeholder"
        >
            <ng-container *ngIf="editable">
                {{'Discover.targeting.distribution.header.subjectLine.placeholder' | localize}}
            </ng-container>
        </label>
    </div>

    <div>
        <label *ngIf="distribution.previewText">
            {{distribution.status !== distributionStatus.draft
                ? previewText
                : distribution.previewText}}
        </label>
        <label
            *ngIf="!distribution.previewText"
            class="agpr-distributionHeader-placeholder"
        >
            <ng-container *ngIf="editable">
                {{'Discover.targeting.distribution.header.previewText.placeholder' | localize}}
            </ng-container>
        </label>
    </div>

    <div class= "agpr-distributionHeader-grid">
        <label class="agpr-distributionHeader-bold">{{'Discover.targeting.distribution.header.fromName' | localize}}</label>
        <label
            *ngIf="distribution.fromName"
        >
            {{distribution.fromName}}
        </label>
        <label
            *ngIf="!distribution.fromName"
            class="agpr-distributionHeader-placeholder"
        >
            <ng-container *ngIf="editable">
                {{'Discover.targeting.distribution.header.fromName.placeholder' | localize}}
            </ng-container>
        </label>

        <label class="agpr-distributionHeader-bold">{{'Discover.targeting.distribution.header.replyEmail' | localize}}</label>
        <label
            *ngIf="distribution.replyEmail"
        >
            {{distribution.replyEmail}}
        </label>
        <label
            *ngIf="!distribution.replyEmail"
            class="agpr-distributionHeader-placeholder"
        >
            <ng-container *ngIf="editable">
                {{'Discover.targeting.distribution.header.replyEmail.placeholder' | localize}}
            </ng-container>
        </label>

        @if (sendFrom) {
            <label class="agpr-distributionHeader-bold">{{'Discover.targeting.distribution.header.sendFrom' | localize}}</label>
            @if (sendFrom.connectionName) {
                <label>
                    {{sendFrom.connectionName + ' (' + sendFrom.connectionEmail + ')'}}
                </label>
            } @else {
                <label>
                    {{ sendFrom.connectionEmail }}
                </label>
            }
        }
        <label
            class="agpr-distributionHeader-bold"
            *ngIf="this.distribution.status === distributionStatus.sent"
        >{{'Discover.targeting.distribution.header.sentDate' | localize}}</label>
        <label
            *ngIf="this.distribution.status === distributionStatus.sent"
        >
            {{distribution.deliverySchedule.getDisplayString(timezone, dateFormat)}}
        </label>
    </div>
</div>
